const appService = {
  namespaced: true,
  state() {
    return {
      isOpenFilterModal: false,
      filterType: '',
    };
  },
  mutations: {
    setFilterState(state, value) {
      state.isOpenFilterModal = value;
    },
    setFilterType(state, value) {
      state.filterType = value;
    },
    clearFilterType(state) {
      state.filterType = '';
    },
  },
};

export default appService;
